import React from 'react';
import { Navigate } from 'react-router-dom';
import { useUser } from '../../context/UserContext';
const AdminRoute: React.FC<{
  children: React.ReactNode;
}> = ({
  children
}) => {
  const {
    user,
    loading
  } = useUser();
  // Show loading state while checking authentication
  if (loading) {
    return <div className="flex items-center justify-center min-h-screen" data-id="element-276">
        <div className="text-center" data-id="element-277">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4" data-id="element-278"></div>
          <p className="text-gray-600" data-id="element-279">Loading...</p>
        </div>
      </div>;
  }
  // Redirect if not authenticated or not admin
  if (!user || !user.isAdmin) {
    return <Navigate to="/" replace data-id="element-280" />;
  }
  return <>{children}</>;
};
export default AdminRoute;